import { render } from "./NcrmActivityTimeline.vue?vue&type=template&id=5ffc5728&scoped=true"
import script from "./NcrmActivityTimeline.vue?vue&type=script&lang=js"
export * from "./NcrmActivityTimeline.vue?vue&type=script&lang=js"

import "./NcrmActivityTimeline.vue?vue&type=style&index=0&id=5ffc5728&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffc5728"]])

export default __exports__